import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: { width: '100%', paddingBottom: 12 },
  firstSection: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  sectionItem: {
    width: '42%',
    paddingVertical: 16,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  sectionItemValues: { ...Fonts.type.bold, marginTop: 4, fontSize: 24 },
  sectionItemExtraFeatures: { marginTop: 4, fontSize: 14.6 },
  separator: theme => ({
    height: 1,
    marginHorizontal: 16,
    backgroundColor: theme.colors.borderColorThree,
  }),
  secondSection: {
    marginTop: 18,
    justifyContent: 'center',
    alignItems: 'center',
  },
  inBoxTitle: { ...Fonts.type.bold, fontSize: 16.6, marginBottom: 10 },
  inBoxItem: { marginTop: 4, fontSize: 16.6 },
  sectionName: { fontSize: 16.6 },
  fullSpecsBtnStyle: theme => ({
    backgroundColor: theme.colors.transparentColor,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 32,
    marginBottom: 28,
  }),
  fullSpecsBtnTextStyle: theme => ({
    color: theme.colors.showMoreColor,
    fontSize: 16.6,
    lineHeight: 30,
  }),
});
